import React from 'react'
import Link from 'gatsby-link'
import css from 'emotion';
import styled from 'react-emotion';

const HeaderContainer = styled.header`
  background: ${props => !props.chapter ? "#222" : "transparent"};
  color: #e3cf34;

  & h1 {
    margin: 0;
    text-transform: uppercase;
    font-size: 17px;

    & span {
      color: #fff;
      margin-left: 20px;
    }

    & i {
      font-size: 40px;
    }
  }

  @media (min-width: 768px) {
    & h1 {
      font-size: 24px;
    }
  }
`

const Header = (props) => (
  <HeaderContainer {...props}>
    <div
      css={{
        margin: '0 auto',
        padding: '1.05rem 1.0875rem',
      }}
    >
      <h1>
        <Link
          to="/"
          css={{
            color: "#e3cf34",
            textDecoration: 'none',
            fontFamily: "'Sonsie One', cursive",
            display: "flex",
            alignItems: "center",
          }}
        >
          <i className="icon-211"/>
          <span>The Hitchhiker's Guide to Javascript</span>
        </Link>
      </h1>
    </div>
  </HeaderContainer>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js